export function getIsDateInDateRange(date: Date, range: [Date, Date]) {
    const timestamp = date.getTime();
    const start = range[0].getTime();
    const end = range[1].getTime();
    return timestamp >= start && timestamp <= end;
}
